import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OAuthService } from '@core/auth/oauth.service';
import { UserService } from '@core/services/user.service';
import { map } from 'rxjs';

export const LogoutGuard: CanActivateFn = () => {
  const authService = inject(OAuthService);
  const userService = inject(UserService);
  const router = inject(Router);

  return authService.signOut().pipe(
    map(() => {
      userService.clearUser();
      return router.parseUrl('login');
    }),
  );
};
